import { addEntityDescriptor, EntityDescriptor, FieldDescriptor } from "@crispico/foundation-react/entity_crud/EntityDescriptor";
import { FieldEditorProps, ManyToOneEditor } from "@crispico/foundation-react/entity_crud/fieldRenderersEditors";
import { CustomQueryEntityEditorPage, sliceCustomQueryEntityEditorPage } from "./CustomQueryEntityEditorPage";
import { addAfterStartupRunnable, entityDescriptors } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { FilterOperators } from "@crispico/foundation-gwt-js";
import { apolloClient } from "@crispico/foundation-react/apolloClient";
import { Filter } from "./Filter";
import React from "react";
import { ClientCustomQuery } from "./ClientCustomQuery";
import { DEFAULT_COMPOSED_FILTER } from "./BlocklyEditorTab";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";

export let customQueryEntityDescriptor: EntityDescriptor;

class MyEntityDescriptor extends EntityDescriptor {
    createNewEntity() {
        const entity: ClientCustomQuery = {
            id: null,
            name: '',
            screen: '',
            customQueryDefinitionObject: {
                sorts: [],
                filter: DEFAULT_COMPOSED_FILTER
            },
            preferredColumnConfig: undefined,
            enabled: true,
            dirty: false,
            color: '',
            displayAsCards: false,
            fromCrudSettings: false,
            emailScheduleRecipientList: undefined,
            emailScheduleCron: '',
            organization: null
        };
        return entity;
    }

}

addAfterStartupRunnable(() => {
    customQueryEntityDescriptor = addEntityDescriptor(new MyEntityDescriptor({
        name: "CustomQuery",
        miniFields: ["name"],
        showInUI: true,
        javaIdType: "Long",
        graphQlIdType: "Long"
    })
        .addFieldDescriptor({ name: "id", type: FieldType.number, enabled: false })
        .addFieldDescriptor({ name: "screen", type: FieldType.entityName })
        .addFieldDescriptor({ name: "name", type: FieldType.string })
        .addFieldDescriptor({ name: "customQueryDefinition", type: FieldType.string, isInDefaultColumnConfigForTable: false })
        .addFieldDescriptor(new class extends FieldDescriptor {
            name = "preferredColumnConfig"
            type = "ColumnConfig"
            protected renderFieldEditorInternal(EditorClass: any, props: FieldEditorProps) {
                return React.createElement(ColumnConfigManyToOneEditor as any, props)
            }
        })
        .addFieldDescriptor({ name: "displayAsCards", type: FieldType.boolean, defaultValue: 0 })
        .addFieldDescriptor({ name: "emailScheduleRecipientList", type: "RecipientList" })
        .addFieldDescriptor({ name: "emailScheduleCron", type: FieldType.cron, optional: true })
    );

    customQueryEntityDescriptor.infoEditor.slice = sliceCustomQueryEntityEditorPage;
    customQueryEntityDescriptor.infoEditor.wrappedComponentClass = CustomQueryEntityEditorPage;

    sliceCustomQueryEntityEditorPage.setEntityDescriptor(customQueryEntityDescriptor);
});

class ColumnConfigManyToOneEditor extends ManyToOneEditor<FieldEditorProps> {
    protected getInnerEntityDescriptor(): EntityDescriptor {
        return entityDescriptors['ColumnConfig'];
    }

    protected async performQuery(searchQuery: string) {
        const filter = Filter.create("entityName", FilterOperators.forString.equals, this.props.formikProps.values.screen)
        return (await apolloClient.query({ query: this.query, variables: this.createFindByStringParams(searchQuery).filter(filter) })).data[this.operationName];
    }
}